export default [
    {
        path: '/internal/reports',
        meta: { title: 'MyMadrivo | Reports', requiresAbility: 'viewReporting' },
        children: [
            {
                path: '/internal/reports/nps-survey-recipients',
                name: 'npsSurveyRecipients',
                component: () => import('@/views/pages/Reports/npsSurveyRecipients.vue'),
                meta: { isInternal: true, requiresAuth: true, requiresAbility: 'viewNpsSurveyRecipients' }
            },
            {
                path: '/internal/reports/tool-usage',
                name: 'toolUsage',
                component: () => import('@/views/pages/Reports/ToolUsageReport.vue'),
                meta: { isInternal: true, requiresAuth: true, requiresAbility: 'viewToolUsage' }
            },
            {
                path: '/internal/reports/offers-without-clicks',
                name: 'offersWithoutClicks',
                component: () => import('@/views/pages/Reports/offersWithoutClicks.vue'),
                meta: { isInternal: true, requiresAuth: true, requiresAbility: 'isAdmin' }
            },
            {
                path: '/internal/reports/creative-approved-no-revenue',
                name: 'creativeApprovedNoRevenue',
                component: () => import('@/views/pages/Reports/CreativeApprovedNoRevenue.vue'),
                meta: { isInternal: true, requiresAuth: true, requiresAbility: 'readCreativeApprovedNoRevenue' }
            },
            {
                path: '/internal/reports/top-offers',
                name: 'topOffers',
                component: () => import('@/views/pages/Reports/topOffers/Index.vue'),
                meta: { isInternal: true, requiresAuth: true, requiresAbility: 'readTopOffers' }
            },
            {
                path: '/internal/reports/caps',
                name: 'caps',
                component: () => import('@/views/pages/Reports/capReports.vue'),
                meta: { isInternal: true, requiresAuth: true, requiresAbility: 'readCapReports' }
            },
            {
                path: '/internal/reports/top-publishers',
                name: 'topPublishers',
                component: () => import('@/views/pages/Reports/TopPublishers.vue'),
                meta: { isInternal: true, requiresAuth: true, requiresAbility: 'readTopPublishers' }
            }
        ]
    }
];
